export const Setting = {
  ADD_APP_CONSTANT: "ADD_APP_CONSTANT",
  GET_APP_CONSTANT: "GET_APP_CONSTANT",
  ADD_EDIT_USER_SEASONS: "ADD_EDIT_USER_SEASONS",
  SEND_FEEDBACK: "SEND_FEEDBACK",
  SETTING_SUCCESS: "SETTING_SUCCESS",
};
